import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconInboxEmpty: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="inbox-empty" maskId="round-filled-radius-0-stroke-1.5-IconInboxEmpty"><path fillRule="evenodd" clipRule="evenodd" d="M5.39161 4H18.6084L23 12.569V20H1V12.569L5.39161 4ZM21.5 13.5V18.5H2.5V13.5H8.04306L9.58056 15.5H14.4194L15.9569 13.5H21.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconInboxEmpty;
